import { useState, useCallback } from 'react';
import apiClient from '../utils/api';

export const useCoach = () => {
  const [coaching, setCoaching] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCoaching = useCallback(async (): Promise<void> => {
    setLoading(true);
    setError(null);

    try {
      const response = await apiClient.get('/coach');
      setCoaching(response.data.coaching);
    } catch (err: any) {
      const errorMessage = err.response?.data?.error || 'Failed to load coaching update. Please try again.';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    coaching,
    fetchCoaching,
    loading,
    error,
  };
};
